<div>
  <mat-card-title style="padding-top: 10px; padding-left: 15px; font-size: 1.0em; font-weight: bold; color: black;">
    {{ this.action===1 ? 'Creating INA/ILP' : this.action===2 ? 'Editing INA/ILP' : 'View INA/ILP'}}
    {{
    this.inaSchoolEnrollmentSelection?.inaSchoolEnrollment?.InaSchoolEnrollment?.StatusTypeId ===1
    ? '(Incomplete)'
    : this.inaSchoolEnrollmentSelection?.inaSchoolEnrollment?.InaSchoolEnrollment?.StatusTypeId ===2 ?
    '(Completed)'
    : ''
    }}
    <span *ngIf="this.inaSchoolEnrollmentSelection?.inaSchoolEnrollment?.Message?.Code!=200 " style="color:red">
      {{this.inaSchoolEnrollmentSelection?.inaSchoolEnrollment?.Message?.Message}}
    </span>
    <!--  <div class="loading-shade">
    <mat-icon *ngIf="loading">{{loading}}
      <mat-spinner diameter="18"></mat-spinner>
    </mat-icon>
  </div> -->
    <!-- <span *ngIf="loading && (progressCurrentValue < 500)" class="progress-spinner-container"
				>
				<mat-progress-spinner class="mat-progress-spinner" [color]="progressColor" [mode]="progressType" [value]="progressCurrentValue">
				</mat-progress-spinner>
			</span> -->
    <span *ngIf="loading" class="progress-spinner-container"
      style="position:absolute; left:50%;transform:translateX(-50%);">
      <mat-progress-spinner [color]="progressColor" mode="indeterminate" [value]="progressCurrentValue">
      </mat-progress-spinner><!-- 			[mode]="progressType"-->
    </span>
    <span style="float: right;">
      <!-- {{results.length}} -->
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="downloadPDF()">
          <span>
            <i class="fa fa-file"></i>
            Export PDF</span>
        </button>
        <!-- [matMenuTriggerFor]="menu"-->
        <!-- <button mat-menu-item (click)="openPDF()"> 
							<span>
								<i class="fa fa-external-link-square"></i>
								Open PDF</span> 
						</button> -->
        <!-- <button mat-menu-item [matMenuTriggerFor]="menu" (click)="downloadXLS()">
							<span>
								<i class="fa fa-file"></i>
								Export to Excel</span> 
						</button>-->
      </mat-menu>
      <button mat-raised-button [matMenuTriggerFor]="menu"><!-- [disabled]="!(results.length > 0)"-->
        Export<mat-icon>more_vert</mat-icon>
      </button>
    </span>

  </mat-card-title>
</div>
<div #contentToExport>
  <form [formGroup]="frmIna">
    <div class="row align-items-start" style="padding-top: 30px; gap: 1rem;">
      <div class="col-12 col-xl-2">
        <div class="ina-ilp-type">
          <span class="mat-body-1">
            School Year
            <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_SchoolYear'"></help-text-btn>
          </span>

          <app-school-year [formControl]="schoolYears" [label]="'School Year'" [yearType]="'SchoolYear'"
            (performancePeriodEvent)="schoolYearEvent($event)" [currentYearModifier]="0" [yearsForward]="0"
            [yearsBack]="2" [reset]="resetField" [startingSchoolYearDate]="startingSchoolYearDate"
            [selectSchoolYear]="selectedSchoolYear" [disabled]="this.action !== 1">
          </app-school-year>
        </div>
      </div>

      <div class="col-12 col-xl-6">
        <div class="ina-ilp-type">
          <span class="mat-body-1">
            School Enrollment
            <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_SchoolEnrollment'"></help-text-btn>
          </span>

          <mat-form-field appearance="fill" class="full-width">
            <mat-select formControlName="schoolEnrollment" required [(value)]="schoolEnrollmentId">
              <mat-option *ngFor="let sEnrollment of schEnrollments" [value]="sEnrollment.ID">
                {{
                '[Region ' + sEnrollment.REGION.CODE + '] - '
                + sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.SCHOOL_YEAR + ': '
                + sEnrollment.SCHOOL.ORGANIZATION.NAME
                + ' (' + sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.GRADE + '/' +
                sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_TYPE + ')'
                + ' [' + '' + ((sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE) ?
                (sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.ENROLLMENT_DATE | cleanDate | simpleDate) : 'No Enrollment Date')
                + ((sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE | cleanDate | simpleDate) ? ' - ' +
                (sEnrollment.SCHOOL_ENROLLMENT_DETAILS_ASL.WITHDRAWAL_DATE | cleanDate | simpleDate) : ' - No Withdrawal Date') + '' + ']'
                }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="schoolEnrollment.invalid && (schoolEnrollment.touched || schoolEnrollment.dirty) && schoolEnrollment.hasError('required')">
              Child must have a valid enrollment for grade P3 or above within these school years.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="col-12 col-xl-3">
        <div class="ina-ilp-type">
          <span class="mat-body-1">INA/ILP Type:
            <help-text-btn class="align-help-text-btn" [helpTextId]="'InaIlp_Type'"></help-text-btn>
          </span>
          <mat-radio-group class="radio-field" formControlName="radioINAILP" aria-label="INA/ILP Type">

            <mat-radio-button color="primary" class="example-radio-button" value="1">30 Day/Initial</mat-radio-button>


            <mat-radio-button color="primary" class="example-radio-button" value="2">Annual</mat-radio-button>

          </mat-radio-group>
          
        </div>
      </div>
    </div>
  </form>

  <div class="row" *ngIf="this.action == 1" style="padding-top: 20px;">
    <div class="col-12">
      <button class="create-ina-button" [disabled]="!enableCreateButton() || loading" (click)="createform()"
        mat-raised-button color="primary">
        Create New INA/ILP Form
      </button>
    </div>
  </div>

  <div *ngIf="showSections">

    <div *ngIf="this.action==2">
      <button (click)="updateChildInfo()" mat-raised-button color="primary">
        Update Child Information
      </button>
    </div>
    <div style="padding-top: 10px" *ngIf="showBasedOnGrade(1)">
      <app-personal-information [action]="this.action" [step]="this.step"
        (updateHistory)="updateTrackingHistory($event)">
      </app-personal-information>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(2)">
      <app-parent-guardian-information [action]="this.action" [step]="step"
        (updateHistory)="updateTrackingHistory($event)">
      </app-parent-guardian-information>
    </div>

    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(3)">
      <app-indicator-status [action]="this.action" [step]="step" (updateHistory)="updateTrackingHistory($event)">
      </app-indicator-status>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(4)">
      <app-preschool [action]="this.action" [step]="step" (updateHistory)="updateTrackingHistory($event)">
      </app-preschool>
    </div>

    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(5)">
      <app-elementary [action]="this.action" [step]="step" (updateHistory)="updateTrackingHistory($event)">
      </app-elementary>
    </div>

    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(6)">
      <app-secondary [action]="this.action" [step]="step" (valid)="validateForm($event,6)"
        (updateHistory)="updateTrackingHistory($event)">
      </app-secondary>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(7)">
      <app-adult-education [action]="this.action" [step]="step"
        (updateHistory)="updateTrackingHistory($event)"></app-adult-education>
    </div>

    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(8)">
      <app-osy [action]="this.action" [step]="step" (valid)="validateForm($event,8)"
        (updateHistory)="updateTrackingHistory($event)"></app-osy>
    </div>

    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(9)">
      <app-health-information [action]="this.action" [step]="step" (valid)="validateForm($event,9)"
        (updateHistory)="updateTrackingHistory($event)">
      </app-health-information>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(10)">
      <app-learning-plan [action]="this.action" [step]="step" (valid)="validateForm($event,10)"
        (updateHistory)="updateTrackingHistory($event)" #learningplan>

      </app-learning-plan>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(11)">
      <app-interviewee [action]="this.action" [step]="step" (valid)="validateForm($event,11)"
        (updateHistory)="updateTrackingHistory($event)">
      </app-interviewee>
    </div>
    <div style="padding-top: 30px" *ngIf="showBasedOnGrade(12)">
      <app-created-by-follow-up [action]="this.action" [step]="step" (valid)="validateForm($event,12)"
        (updateHistory)="updateTrackingHistory($event)">
      </app-created-by-follow-up>
    </div>

  </div>

  <div style="padding-top: 30px"
    *ngIf="showSections && this.inaSchoolEnrollmentSelection.inaSchoolEnrollment.InaSchoolEnrollment.StatusTypeId==1 && this.action!=3">
    <button mat-raised-button color="primary" [disabled]="enableCompleteButton()" (click)="saveCompleteform()">
      Complete Form
    </button>
  </div>
  <div style="padding-top: 30px">

  </div>
</div>